import { createReducer, on } from '@ngrx/store';
import * as ServiceInventoryActions from './service-inventory.actions';
import { ServiceInventoryState, ServiceInventoryItem } from './service-inventory.model';

const initialState: ServiceInventoryState = {
  items: {},
  loading: false,
  error: undefined,
};

export const serviceInventoryReducer = createReducer(
  initialState,
  on(ServiceInventoryActions.loadServiceInventory, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(ServiceInventoryActions.loadServiceInventorySuccess, (state, { items }) => ({
    ...state,
    loading: false,
    items: {
      ...state.items,
      ...items.reduce((acc, item) => {
        acc[item.key] = item;
        return acc;
      }, {} as Record<string, ServiceInventoryItem>)
    },
  })),
  on(ServiceInventoryActions.loadServiceInventoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    items: { ...state.items },
  })),
  on(ServiceInventoryActions.resetServiceInventory, () => initialState),
  on(ServiceInventoryActions.updateServiceState, (state, { key, state: newState }) => ({
    ...state,
    items: {
      ...state.items,
      [key]: { ...state.items[key], state: newState },
    },
  }))
);
